import {pointerUtils, type CreateExtArgs} from '@wix/document-manager-core'
import type {ConnectionList, ControllerConnectionItem, IConnectionItem, Pointer} from '@wix/document-services-types'
import _ from 'lodash'
import {COMP_DATA_QUERY_KEYS_WITH_STYLE, MASTER_PAGE_ID, VIEW_MODES} from '../../../constants/constants'

export const getComponentData = (createExtArgs: CreateExtArgs, compPtr: Pointer): any => {
    const {dal, pointers} = createExtArgs
    const dataQueryPointer = pointerUtils.getInnerPointer(compPtr, COMP_DATA_QUERY_KEYS_WITH_STYLE.data)
    const dataQuery = dal.get(dataQueryPointer)
    if (!dataQuery) {
        return null
    }
    const dataId = _.trimStart(dataQuery, '#')
    const pagePointer = pointers.structure.getPageOfComponent(compPtr)
    if (!pagePointer) {
        return null
    }
    const dataPointer = pointers.data.getDataItem(dataId, pagePointer.id)
    return dal.get(dataPointer)
}

export const getComponentConnections = (createExtArgs: CreateExtArgs, compPtr: Pointer): IConnectionItem[] => {
    const {dal, pointers} = createExtArgs

    const getControllerRef = (controllerId: string, pagePointer: Pointer): Pointer | null => {
        if (!controllerId || !pointers.platform?.getControllerInPageByDataId) {
            return null
        }
        const isMobileView = pagePointer.type === VIEW_MODES.MOBILE
        const controller = pointers.platform.getControllerInPageByDataId(pagePointer, isMobileView, controllerId)
        if (controller) {
            return controller
        }
        const masterPagePointer = pointers.page.getPagePointer(MASTER_PAGE_ID)
        if (!masterPagePointer || (pointers.structure.isPage(pagePointer) && pagePointer.id === MASTER_PAGE_ID)) {
            return null
        }
        return pointers.platform.getControllerInPageByDataId(masterPagePointer, isMobileView, controllerId)
    }

    const connectionQueryPointer = pointerUtils.getInnerPointer(compPtr, COMP_DATA_QUERY_KEYS_WITH_STYLE.connections)
    const connectionQuery = dal.get(connectionQueryPointer)
    if (!connectionQuery) {
        return []
    }
    const connectionId = _.trimStart(connectionQuery, '#')
    const pagePointer = pointers.structure.getPageOfComponent(compPtr)
    if (!pagePointer) {
        return []
    }
    const connectionPointer = pointers.data.getConnectionsItem(connectionId, pagePointer.id)
    const connectionData: ConnectionList | undefined = dal.get(connectionPointer)
    if (!connectionData?.items) {
        return []
    }
    return connectionData.items
        .filter((item): item is ControllerConnectionItem => item.type !== 'WixCodeConnectionItem')
        .map(item => {
            const deserialized = item.controllerId
                ? {..._.omit(item, 'controllerId'), controllerRef: getControllerRef(item.controllerId, pagePointer)}
                : {...item}
            const {config} = deserialized
            if (typeof config === 'string') {
                try {
                    return {...deserialized, config: JSON.parse(config)}
                } catch (_e) {
                    /* keep as-is */
                }
            }
            return deserialized
        })
}
